export default "__VITE_ASSET__CDlBz1uq__"